import React from "react";
import { Box } from "@mui/material";
import CustomButton from "../../../../UIElements/CustomButton";
import "../../../../components-styles.scss";
import "../../../profil-styles.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputField from "../../../../UIElements/InputField";
import CancelModalButton from "../../../../UIElements/CustomModal/CancelModalButton";
import { isValidSiret } from "../../../../../helpers";
import { getEstablishmentBySiret } from "../../../../../services";

type EditSiretFormProps = {
    onSubmit: Function;
    defaultValue?: {
        siret: string;
    };
};

const validationSchema = yup.object({
    siret: yup
        .string()
        .required("Veuillez renseigner le numéro de SIRET")
        .test("validSiret", "Le numéro de siret n'est pas valide", (siret) =>
            isValidSiret(siret)
        )
        .test(
            "siretAlreadyExist",
            "Un établissement existe déjà avec ce numéro de SIRET.",
            async (siret) => {
                if (siret && isValidSiret(siret)) {
                    const establishmentBySiretRes =
                        await getEstablishmentBySiret(siret);
                    return establishmentBySiretRes.id ? false : true;
                }
                return true;
            }
        ),
});

export default function EditSiretForm({
    onSubmit,
    defaultValue,
}: EditSiretFormProps) {
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            siret: defaultValue?.siret ?? "",
        },
        resolver: yupResolver(validationSchema),
    });

    const _onSubmit = (data: any) => {
        onSubmit(data);
    };

    return (
        <Box className="profil-form-root">
            <form
                onSubmit={handleSubmit(_onSubmit)}
                className="profil-form-container"
            >
                <Controller
                    name="siret"
                    control={control}
                    render={({ field: { ref, ...others } }) => {
                        return (
                            <InputField
                                errortext={
                                    errors.siret ? errors.siret.message : ""
                                }
                                {...others}
                                type="numeric"
                                outlinedinputsx={{
                                    border: "2px solid  #E3E6E8",
                                }}
                                inputProps={
                                    {
                                        // maxLength: 14,
                                        // type: "numeric",
                                    }
                                }
                                label={"Numéro de SIRET *"}
                                fullWidth
                            />
                        );
                    }}
                />

                <CustomButton
                    type="submit"
                    label="Enregister"
                    customsx={{
                        width: "100%",
                    }}
                />
                <CancelModalButton
                    customsx={{
                        width: "100%",
                    }}
                />
            </form>
        </Box>
    );
}
